const calculateDiscount = (price, getDetails) => {
  if (getDetails?.type === 3) {
    return {
      discountAmount: getDetails?.discount,
      totalPay: getDetails?.after_discount_applied
    };
  } else if (getDetails?.discount_percentage && getDetails?.maximum_discount) {
    const discountPercentage = getDetails.discount_percentage;
    const discountAmountFromPercentage = (price * discountPercentage) / 100;

    if (discountAmountFromPercentage > getDetails.maximum_discount) {
      return {
        discountAmount: getDetails.maximum_discount,
        totalPay: price - getDetails.maximum_discount
      };
    } else {
      return {
        discountAmount: discountAmountFromPercentage,
        totalPay: price - discountAmountFromPercentage
      };
    }
  } else if (getDetails?.flat_amount) {
    return {
      discountAmount: getDetails.flat_amount,
      totalPay: price - getDetails.flat_amount
    };
  } else {
    return {
      discountAmount: 0,
      totalPay: price
    };
  }
};

export default calculateDiscount;
